import React, { useState } from 'react'

// A received URL is not proof that the browser loaded the image. No generation retries.
const StoryboardImage = ({ src, label, onError }) => {
  const [state, setState] = useState('loading')
  return <>
    <img alt={label} src={src} onLoad={(event) => setState(event.currentTarget.naturalWidth > 0 ? 'loaded' : 'error')}
      onError={() => { setState('error'); onError?.() }}
      className={`absolute inset-0 w-full h-full object-contain ${state === 'loaded' ? '' : 'invisible'}`} />
    {state !== 'loaded' && <div role="status" className="absolute inset-0 flex items-center justify-center text-white text-[13px]">
      {state === 'loading' ? 'Image loading' : 'Image unable to load'}
    </div>}
  </>
}
export default StoryboardImage